//import ReactGA from 'react-ga';
import ReactGA from "react-ga4";
import log from './log';
import { Capacitor } from '@capacitor/core';

const GA = {
  pageview: () => {
    if (process.env.REACT_APP_ENV !== 'prod'){
      return;
    }

    //ReactGA.initialize('UA-166037494-1');
    ReactGA.initialize(process.env.REACT_APP_GA4);
    //ReactGA.pageview(window.location.pathname + window.location.search);
    ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
  },
  track: (e) => {
    log.trace(e);

    /*if (process.env.REACT_APP_ENV !== 'prod'){
      return;
    }*/

    //ReactGA.initialize('UA-166037494-1');
    ReactGA.initialize(process.env.REACT_APP_GA4)
    
    // if conversion event
    if (e.action.startsWith('proUnlocked')){
      log.traceTag('send proUnlocked event', e)
      ReactGA.event(
        e.action)
      return;
    }

    // is custom event
    ReactGA.event({
      category: `${e.category}_${Capacitor.getPlatform()}`, // adding platform to category
      action: `${e.action}_${Capacitor.getPlatform()}`, // and action
      label: e.label,
      value: e.value
    });
  }
}

export default GA;
